module.exports = __webpack_public_path__ + "img/ground.b3bc5a77.png";